var $bd065904f1420f31$exports = {};
$bd065904f1420f31$exports = {
    "(optional)": `(\u{43D}\u{435}\u{43E}\u{431}\u{43E}\u{432}\u{2019}\u{44F}\u{437}\u{43A}\u{43E}\u{432}\u{43E})`,
    "(required)": `(\u{43E}\u{431}\u{43E}\u{432}\u{2019}\u{44F}\u{437}\u{43A}\u{43E}\u{432}\u{43E})`
};


export {$bd065904f1420f31$exports as default};
//# sourceMappingURL=uk-UA.module.js.map
